module.exports = __webpack_public_path__ + "burundi.svg?09d7af21e407967b089c03347444d5fd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/burundi.svg
// module id = 124
// module chunks = 10